module.exports = __webpack_public_path__ + "img/angle-left.1a34fb42.svg";